import { Control } from 'react-hook-form';
import { TextInputField } from '@brighte/form-components';
import { HouseholdType } from '@brighte/validation';
import { Alert } from '@spark-web/alert';
import { Box } from '@spark-web/box';
import { InformationCircleIcon } from '@spark-web/icon';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { HOUSEHOLD, LABELS } from '@utils';

function ApplicationDetails({ control }: { control: Control<HouseholdType> }) {
  const { ADD_PARTNER_INFO, PARTNER_DETAILS_HEADER } = HOUSEHOLD;

  const { FIRST_NAME, LAST_NAME, EMAIL, MOBILE_NUMBER } = LABELS;
  return (
    <Box background="cautionLow">
      <Stack gap="xxlarge" padding="xlarge">
        <Alert tone="caution" icon={InformationCircleIcon}>
          {ADD_PARTNER_INFO}
        </Alert>
        <Text size="large">{PARTNER_DETAILS_HEADER}</Text>
        <TextInputField name="jointApplicant.firstName" control={control} label={FIRST_NAME} />
        <TextInputField name="jointApplicant.lastName" control={control} label={LAST_NAME} />
        <TextInputField name="jointApplicant.email" control={control} label={EMAIL} />
        <TextInputField name="jointApplicant.phone" control={control} label={MOBILE_NUMBER} />
      </Stack>
    </Box>
  );
}

export default ApplicationDetails;
